export default __webpack_public_path__ + "65659f215f9ffe4fcb2387d52e267cf9.svg";